export var newFileExperienceClassName = 'new-file-experience-wrapper';